import Dispatcher from 'search/Dispatcher';
import { ActionTypes } from 'search/constants';
import invariant from 'invariant';
import SearchAPI from 'search/api/searchAPI';

export default {
  changePage(pageNumber) {
    Dispatcher.handleViewAction({
      type: ActionTypes.CHANGE_PAGE,
      page: pageNumber
    });
    SearchAPI.searchVenues();
  },

  changeEventTypeFilter(eventTypeId) {
    Dispatcher.handleViewAction({
      type: ActionTypes.CHANGE_FILTER_EVENT_TYPE,
      eventTypeId: eventTypeId
    });
    SearchAPI.searchVenues();
  },

  changeVenueTypeFilter(venueTypeIds) {
    Dispatcher.handleViewAction({
      type: ActionTypes.CHANGE_FILTER_VENUE_TYPES,
      venueTypeIds: venueTypeIds
    });
    SearchAPI.searchVenues();
  },

  changePeopleFilter(people) {
    Dispatcher.handleViewAction({
      type: ActionTypes.CHANGE_FILTER_PEOPLE,
      people: people
    });
    SearchAPI.searchVenues();
  },

  // TODO: Come up with a better name #peoplefilter
  changePeopleFilterFilter(filterType) {
    Dispatcher.handleViewAction({
      type: ActionTypes.CHANGE_FILTER_PEOPLE_FILTER,
      filterType: filterType
    });
    SearchAPI.searchVenues();
  },

  changeLocationFilter(location) {
    Dispatcher.handleViewAction({
      type: ActionTypes.CHANGE_FILTER_LOCATION,
      location: location
    });
    SearchAPI.searchVenues();
  },

  changeSorting(sort) {
    Dispatcher.handleViewAction({
      type: ActionTypes.CHANGE_SEARCH_SORTING,
      sort: sort
    });
    SearchAPI.searchVenues();
  },

  changeVenueServicesFilter(venueServices) {
    Dispatcher.handleViewAction({
      type: ActionTypes.CHANGE_FILTER_VENUE_SERVICES,
      venueServices: venueServices
    });
    SearchAPI.searchVenues();
  },

  changeVenueTitleFilter(title) {
    Dispatcher.handleViewAction({
      type: ActionTypes.CHANGE_FILTER_VENUE_TITLE,
      title: title
    });
    SearchAPI.searchVenues();
  },

  changeAvailabilityFilter(availability) {
    Dispatcher.handleViewAction({
      type: ActionTypes.CHANGE_FILTER_AVAILABILITY,
      availability: availability
    });
    SearchAPI.searchVenues();
  },

  toggleSearchOnMapDrag(value) {
    invariant(
      typeof value === 'boolean',
      'toggleSearchOnMapDrag expects a boolean value representing the toggled ' +
        'value. Received type: "%s"',
      typeof value
    );
    Dispatcher.handleViewAction({
      type: ActionTypes.TOGGLE_SEARCH_ON_MAP_DRAG,
      value: value
    });
  },

  focusSearchResult(id) {
    Dispatcher.handleViewAction({
      type: ActionTypes.FOCUS_SEARCH_RESULT,
      id: id
    });
  }
};
